module.exports = __webpack_public_path__ + "img/blue-whatsapp-logo.d67efa22.png";